import { AutoCompleteInput } from "lib/common";
import { checkVatClassificationFetching, getVatClassificationData } from "selectors/vatClassification";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Arrays from "utils/Arrays";
import Constants from "const/Constants";
import React, { useCallback, useMemo, useRef, useState } from "react";
import moment from "moment";

const SelectVatClassification = (props) => {
  const {
    issueDate,
    value,
    invalid,
    disabled,
    inputProps,
    useTooltip,
    onChange,
    ...restProps
  } = props;

  const inputRef = useRef();

  const { uiTexts } = useSelector(getTextsData);

  const fetchingData = useSelector(checkVatClassificationFetching);

  const vatClassification = useSelector(getVatClassificationData);

  const filteredData = useMemo(() => {
    return vatClassification.filter((item) => !item.default);
  }, [vatClassification]);

  const [inputValue, setInputValue] = useState(() => {
    const found = Arrays.findByKey(filteredData, "code", value);

    return found ? `${found.code}: ${found.name}` : (value || "");
  });

  const options = useMemo(() => {
    return filteredData
      .filter(({ validFrom }) => !issueDate || !validFrom || !moment.utc(validFrom).isAfter(moment.utc(issueDate), "day"))
      .map((item) => `${item.code}: ${item.name}`)
      .sort((itemA, itemB) => itemA.localeCompare(itemB));
  }, [filteredData, issueDate]);

  const handleChange = useCallback((event) => {
    setInputValue(event.target.value);
    onChange(null);
  }, [onChange]);

  const handleAutoComplete = useCallback((event) => {
    const [newCode] = event.target.value.split(":");

    const found = Arrays.findByKey(filteredData, "code", newCode);

    if (found) {
      onChange(found.code);
      setInputValue(`${found.code}: ${found.name}`);
    }
  }, [filteredData, onChange]);

  return (
    <AutoCompleteInput
      {...restProps}
      title={inputValue}
      disabled={disabled || fetchingData}
      invalid={invalid || (!!(value || inputValue) && !Arrays.findByKey(filteredData, "code", value))}
      ref={inputRef}
      placeholder={uiTexts.selectVatClassification}
      value={inputValue}
      similarityCoef={Constants.DATA_SIMILARITY_COEFFICIENT}
      toggleProps={inputProps}
      options={options}
      onChange={handleChange}
      onAutoComplete={handleAutoComplete} />
  );
};

export default React.memo(SelectVatClassification);
